import React, { Component } from 'react';
import { Button, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Card from '../../../../components/Card/Card';
import { currencyToSign } from '../../../../utils/utils';
import OffersListTable from './OffersListTable';

class OffersListItem extends Component {
  // renderControls = () => {
  //   const { onRequestOfferAccess, modifies, id, title } = this.props;
  //   return modifies.is_my ? (
  //     <Button color="primary" size="sm" tag={Link} to={`/tools/flows/create?offer=${id}`} outline>
  //       <FormattedMessage id="offer.buttons.create-flow" defaultMessage="Create flow" />
  //     </Button>
  //   ) : (
  //       <Button
  //         type="button"
  //         color="primary"
  //         size="sm"
  //         onClick={() => onRequestOfferAccess(id, title)}
  //       >
  //         <FormattedMessage id="offer.buttons.activate-offer" defaultMessage="Activate" />
  //       </Button>
  //     );
  // };

  renderControls = () => {
    const {
      onRequestOfferAccess,
      modifies: { is_my, is_private, no_access },
      id,
      title,
    } = this.props;
    return is_private ? (
      <span className="private-access-text">
        <i className="icon-lock" />{' '}
        <span>
          <FormattedMessage id="offers.private-access" defaultMessage="Private access" />
        </span>
      </span>
    ) : no_access ? (
      <Button
        tag={Link}
        color="primary"
        size="sm"
        to={`/tickets/create?theme=getPrivateOffers&offer=${id}`}
      >
        <FormattedMessage id="offer.buttons.get-access" defaultMessage="Get access" />
      </Button>
    ) : (
      <Button
        onClick={() => onRequestOfferAccess(id, title, is_my)}
        color="primary"
        size="sm"
        outline
      >
        <FormattedMessage id="offer.buttons.create-flow" defaultMessage="Create flow" />
      </Button>
    );

    // <Button
    //   type="button"
    //   color="primary"
    //   size="sm"
    //   onClick={() => onRequestOfferAccess(id, title)}
    // >
    //   <FormattedMessage id="offer.buttons.activate-offer" defaultMessage="Activate" />
    // </Button>
  };

  renderTitle = (title) => <span>{title}</span>;

  getOfferImgSrc = () => {
    const { images, offerSettings } = this.props;
    if (
      (!images || (images && !images[100])) &&
      (!offerSettings || (offerSettings && !offerSettings['images_path']))
    ) {
      return null;
    } else {
      return `${offerSettings['images_path']}${images[100].replace('100x100', '300x300')}`;
    }
  };

  getStats = (stat, isNew, sign) =>
    isNew ? 'NEW' : stat > 0 ? `${stat} ${currencyToSign(sign)}` : '—';

  getOfferStats = (stats = [], type, period, sign) => {
    const stat = stats.find((stat) => stat.period === period);
    return this.getStats(stat[type], undefined, sign);
  };

  render() {
    const {
      title,
      stats,
      currencies,
      pixels,
      offer_geo: { prices },
      id,
      countries,
      modifies: { coins, exclusive, g, d, is_new, is_private, no_access },
      admit,
    } = this.props;
    const [baseCurrency] = currencies;

    return (
      <Card.WithControls
        title={this.renderTitle(title)}
        controls={[this.renderControls()]}
        className="offers-list-item"
      >
        <Card.Body>
          <Row className="offer-list-item-row">
            {!is_private && (
              <Link
                style={{ textDecoration: 'none', color: 'inherit' }}
                to={
                  no_access ? `/tickets/create?theme=getPrivateOffers&offer=${id}` : `/offers/${id}`
                }
                className="offer-list-item-link"
              />
            )}
            <Col lg="2" md="4" sm="6" xs="6" xxs="6">
              <img className="img-fluid rounded-circle" src={`${this.getOfferImgSrc()}?1`} alt="" />
              <div className="badges">
                {exclusive && <span className="badge badge-danger mr-1">exclusive</span>}
                {is_new && <span className="badge badge-success mr-1">new</span>}
                {admit.private && <span className="badge badge-private">private</span>}
              </div>
            </Col>
            {/* на офферах категории гемблинг стата CR и EPC не должна показываться, OFFERRUM-1170 */}
            {!g && (
              <Col lg="2" md="4" sm="6" xs="6" xxs="6">
                <p className="offers-list-block-title">
                  <FormattedMessage id="offers.stats" defaultMessage="Indicators" />
                </p>
                <ul className="list-unstyled offers-list-stats">
                  <li className="offers-list-stats-item">
                    <span className="offers-list-stats-name">CR: </span>
                    <span className="offers-list-stats-value">
                      {this.getOfferStats(stats, 'cr', 'week', '%')}
                    </span>
                  </li>
                  <li className="offers-list-stats-item">
                    <span className="offers-list-stats-name">EPC: </span>
                    <span className="offers-list-stats-value">
                      {this.getOfferStats(stats, 'epc', 'week', baseCurrency)}
                    </span>
                  </li>
                  {/* на офферах категории знакомства стата Approve не должна показываться, OFFERRUM-1466 */}
                  {!d && (
                    <li className="offers-list-stats-item">
                      <span className="offers-list-stats-name">Approve: </span>
                      <span className="offers-list-stats-value">
                        {stats.find((stat) => stat.period === 'week').new
                          ? 'NEW'
                          : stats.find((stat) => stat.period === 'week').new === 0
                          ? '-'
                          : this.getOfferStats(stats, 'rate', 'week', '%')}
                      </span>
                    </li>
                  )}
                </ul>
              </Col>
            )}
            <Col lg="8">
              <OffersListTable
                isPrivate={is_private}
                prices={prices}
                pixels={pixels}
                id={id}
                coins={coins}
                countries={countries}
                noAccess={no_access}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card.WithControls>
    );
  }
}

export default OffersListItem;
